import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Navbar";
import { CONTACT, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-stone-950 pb-10 pt-20 text-stone-400">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Wordmark dark />
            <p className="mt-6 max-w-sm text-sm font-light leading-relaxed">
              Luxury restroom trailer rentals for weddings, corporate events, festivals, private parties,
              construction projects, and film &amp; TV production — delivered across {CONTACT.region}.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-brand-bronze">Explore</p>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={`/${l.href}`} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="link-underline text-sm font-light hover:text-stone-50 transition-colors duration-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-brand-bronze">Get in touch</p>
            <ul className="mt-6 space-y-3 text-sm font-light">
              <li>
                <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="link-underline hover:text-stone-50 transition-colors duration-300">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} data-testid="footer-email-link" className="link-underline hover:text-stone-50 transition-colors duration-300">
                  {CONTACT.email}
                </a>
              </li>
              <li data-testid="footer-address">{CONTACT.address}</li>
            </ul>
            <Link
              to="/book"
              data-testid="footer-book-button"
              className="mt-8 inline-block border border-brand-bronze/50 px-6 py-3 text-sm tracking-wide text-brand-bronze transition-colors duration-300 hover:bg-brand-bronze hover:text-stone-900"
            >
              Book Your Trailer
            </Link>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-stone-800 pt-8 text-xs font-light sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} LooXury Rentals. All rights reserved.</p>
          <p>Serving {CONTACT.region} · Delivery fees may apply based on location</p>
        </div>
      </div>
    </footer>
  );
}
